/*------------------------------------*\
    COPYRIGHT YEAR
\*------------------------------------*/
class CopyrightYear {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        const startYear = self.elem.textContent;
        const currentYear = new Date().getFullYear();

        if (currentYear != startYear) {
            self.elem.textContent = `${startYear} - ${currentYear}`;
        }
    }
}

export default CopyrightYear;
